import type { FastifyInstance } from "fastify";
import { env } from "../config/env.js";

export const generateAccessToken = (
  app: FastifyInstance,
  userId: string,
): string => {
  const token = app.jwt.sign(
    { userId, type: "access" },
    { expiresIn: env.ACCESS_TOKEN_EXPIRE_IN },
  );
  return token;
};

export const generateRefreshToken = (
  app: FastifyInstance,
  userId: string,
): string => {
  const token = app.jwt.sign(
    { userId, type: "refresh" },
    { expiresIn: env.REFRESH_TOKEN_EXPIRE_IN },
  );
  return token;
};
